module.exports = __webpack_public_path__ + "img/curve_line_icon.b633d915.svg";